import template from './ecocode-trustpilot-welcome.html.twig';

Shopware.Component.register('ecocode-trustpilot-welcome', {
    template,
    emits:['frw-set-title','buttons-update', 'modal-close'],
    created() {
        this.createdComponent();
    },
    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    },
    methods: {
        createdComponent() {
            this.updateButtons();
            this.setTitle();
        },
        setTitle() {
            this.$emit('frw-set-title', 'Trustpilot setup');
        },
        updateButtons() {
            const buttonConfig = [
                {
                    key: 'cancel',
                    label: this.$tc('ecocode-trustpilot.general.buttonCancel'),
                    position: 'right',
                    variant: null,
                    action: this.onCancel.bind(this),
                    disabled: false
                },
                {
                    key: 'next',
                    label: this.$tc('sw-first-run-wizard.general.buttonNext'),
                    position: 'right',
                    variant: 'primary',
                    action: 'ecocode.trustpilot.setup.connect',
                    disabled: false
                }
            ];

            this.$emit('buttons-update', buttonConfig);
        },
        onCancel() {
            this.$emit('modal-close');
        }
    }
});
